var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tcCopy)?_c('p',{staticClass:"opacity-60 margin-bottom-0 font-size-small",domProps:{"innerHTML":_vm._s(_vm.tcCopy)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"g-recaptcha",attrs:{"id":_vm.widgetId}})])}
var staticRenderFns = []

export { render, staticRenderFns }